"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.secretModuleConstants = exports.vaultLoadingMessage = exports.pageTitle = exports.translatedStrings = exports.translatedInitialTab = exports.VaultLandingTypes = exports.classes = void 0;

var _externalization = require("../../externalization");

var classes = {
  secretsRequestsApprovalsContainer: 'secrets-requests-approvals-container'
};
exports.classes = classes;
var VaultLandingTypes = {
  VAULT_LANDING_REQUEST: 'VAULT_LANDING_REQUEST',
  VAULT_LANDING_LOADING: 'VAULT_LANDING_LOADING',
  VAULT_LANDING_SUCCESS: 'VAULT_LANDING_SUCCESS',
  VAULT_LANDING_FAILURE: 'VAULT_LANDING_FAILURE'
};
exports.VaultLandingTypes = VaultLandingTypes;
var translatedInitialTab = [{
  title: (0, _externalization.translate)('SECRETS_MODULE.ALL_SECRETS')
}, {
  title: (0, _externalization.translate)('SECRETS_MODULE.MY_REQUESTS')
}, {
  title: (0, _externalization.translate)('SECRETS_MODULE.MY_APPROVALS')
}];
exports.translatedInitialTab = translatedInitialTab;
var translatedStrings = {
  approvalPendingText: (0, _externalization.translate)('SECRETS_MODULE.APPROVAL_PENDING_TEXT'),
  approvalRequiredText: (0, _externalization.translate)('SECRETS_MODULE.APPROVAL_REQUIRED_TEXT'),
  approvalDeniedText: (0, _externalization.translate)('SECRETS_MODULE.APPROVAL_DENIED_TEXT'),
  availableText: (0, _externalization.translate)('SECRETS_MODULE.AVAILABLE_TEXT'),
  alreadyApproved: (0, _externalization.translate)('SECRETS_MODULE.ALREADY_APPROVED'),
  alreadyRejected: (0, _externalization.translate)('SECRETS_MODULE.ALREADY_REJECTED'),
  alreadyExpired: (0, _externalization.translate)('SECRETS_MODULE.ALREADY_EXPIRED'),
  viewSecret: (0, _externalization.translate)('SECRETS_MODULE.VIEW_SECRET'),
  accessProfile: (0, _externalization.translate)('SECRETS_MODULE.ACCESS_PROFILE'),
  rejectedStatus: (0, _externalization.translate)('SECRETS_MODULE.REJECTED_STATUS'),
  approvedStatus: (0, _externalization.translate)('SECRETS_MODULE.APPROVED_STATUS'),
  timeOutStatus: (0, _externalization.translate)('SECRETS_MODULE.TIMEOUT_STATUS'),
  cancelled: (0, _externalization.translate)('SECRETS_MODULE.CANCELLED_STATUS'),
  noneText: (0, _externalization.translate)('SECRETS_MODULE.NONE_TEXT'),
  accessRequest: (0, _externalization.translate)('SECRETS_MODULE.ACCESS_REQUEST'),
  secret: (0, _externalization.translate)('SECRETS_MODULE.SECRET')
};
exports.translatedStrings = translatedStrings;
var pageTitle = (0, _externalization.translate)('SECRETS_MODULE.MY_SECRETS');
exports.pageTitle = pageTitle;
var vaultLoadingMessage = (0, _externalization.translate)('VAULT_DETAILS_FETCHING_MESSAGE');
exports.vaultLoadingMessage = vaultLoadingMessage;
var secretModuleConstants = {
  pendingText: 'pending',
  approvalRequiredText: 'approvalrequired',
  denyText: 'deny',
  allowText: 'allow',
  accessDeniedText: 'access denied',
  rejectedText: 'rejected',
  timeOutText: 'timeout',
  secretReadActionName: 'sm.secret.read',
  profileAccessActionName: 'papservice.profile.access',
  approvedText: 'approved',
  requestExpiredText: 'request expired',
  cancelled: 'withdrawn',
  papService: 'papservice',
  secretManager: 'secretmanager'
};
exports.secretModuleConstants = secretModuleConstants;